import {createContext} from 'react';

type BuyOrActivateLicenseContextType = {
    buyLicenseUrl: string;
    activateLicenseUrl: string;
    showBuyActivateLinks: boolean;
};

const BuyOrActivateLicenseContext = createContext<BuyOrActivateLicenseContextType>(
    {} as BuyOrActivateLicenseContextType
);

export {BuyOrActivateLicenseContext};
